export default function CtaSection() {
  return (
    <section className="py-24 px-4 md:px-6 lg:px-8 bg-gray-50 text-primary-foreground">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className=" md:text-3xl text-2xl font-bold mb-6">
          Ready to Streamline Your
          <span className="text-[#151C62] border-b-2 border-[#151C62] pb-1">
            {" "}
            Business Operations ?
          </span>
        </h2>
        <p className="text-xl mb-8">
          Join countless clients who trust us for expert advisory services in
          <strong> Taxation</strong>, <strong> Tax Planning</strong>,
          <strong> Back Office Accounting</strong>,
          <strong> Corporate/LLP Advisory</strong>,<strong> Audits</strong>, and
          more. Simplify your processes with our growing expertise in{" "}
          <strong> Management Consultancy</strong>.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4 items-center">
          <a href="#services">
            <button className="w-48 px-4 py-2 rounded-full border border-neutral-600 text-white bg-[#151C62] transition duration-300  hover:text-white">
              Explore Our Services
            </button>
          </a>
          <a href="#contact">
            <button className="w-48 px-4 py-2 rounded-full border border-[#151C62] bg-transparent text-[#151C62] transition duration-300 hover:bg-transparent hover:text-black hover:border-black focus:outline-none focus:ring-2 focus:ring-[#151C62]">
              Book a Consultation
            </button>
          </a>
        </div>
      </div>
    </section>
  );
}
